/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Lastlearningmaterialorderdate4Inputs */

const de__field_lastlearningmaterialorderdate4 = /** @type {(inputs: _Field_Lastlearningmaterialorderdate4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letzte Lernmaterial-Bestellung`)
};

/**

* @param {_Field_Lastlearningmaterialorderdate4Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_lastlearningmaterialorderdate4 = /** @type {((inputs?: _Field_Lastlearningmaterialorderdate4Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Lastlearningmaterialorderdate4Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_lastlearningmaterialorderdate4(inputs)
});
export { _field_lastlearningmaterialorderdate4 as "_field_lastLearningMaterialOrderDate" }